import { render, staticRenderFns } from "./VariableScreenOfMultiFile.vue?vue&type=template&id=1139fde2&"
import script from "./VariableScreenOfMultiFile.vue?vue&type=script&lang=ts&"
export * from "./VariableScreenOfMultiFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports